import { createContext } from 'react';

const EditAppoimentFormContext = createContext(null);

export default EditAppoimentFormContext;